import { useEffect, useState, useRef } from "react";
import { doc, onSnapshot, collection, getDocs } from "firebase/firestore";
import { databasePromise, getAuthAsync } from "configuration";
import { analyticsService } from "services";
import { useLike } from "./useLike";

export const useDeal = (dealId) => {
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const trackingAttempted = useRef(false);

  const { like: likeDeal, unlike: unlikeDeal } = useLike("deals");

  useEffect(() => {
    if (!dealId) return;

    setLoading(true);
    setError(null);
    trackingAttempted.current = false;
    let unsubscribe;
    let cancelled = false;

    databasePromise.then((db) => {
      if (cancelled) return;
      const dealRef = doc(db, "deals", dealId);
      unsubscribe = onSnapshot(
        dealRef,
        async (snapshot) => {
          try {
            if (snapshot.exists()) {
              const dealData = { id: snapshot.id, ...snapshot.data() };

              const locationsSnapshot = await getDocs(
                collection(db, "deals", dealData.id, "locations"),
              );

              dealData.locations = locationsSnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
              }));

              setDeal(dealData);
              setLoading(false);

              if (!trackingAttempted.current) {
                trackingAttempted.current = true;
                (async () => {
                  try {
                    const auth = await getAuthAsync();
                    const userId = auth.currentUser?.uid || null;
                    await analyticsService.trackView("deal", dealId, userId);
                  } catch (trackError) {
                    console.error("Background tracking failed:", trackError);
                  }
                })();
              }
            } else {
              setDeal(null);
              setLoading(false);
            }
          } catch (snapshotError) {
            console.error("Error processing snapshot:", snapshotError);
            setError(snapshotError.message);
            setLoading(false);
          }
        },
        (err) => {
          console.error("Firestore listener error:", err);
          setError(err.message);
          setLoading(false);
        },
      );
    });

    return () => {
      cancelled = true;
      unsubscribe?.();
    };
  }, [dealId]);

  return { deal, loading, error, likeDeal, unlikeDeal };
};